import React from "react";
import "components/General/Appearance.css";
import TextTheme from "components/General/Text/TextTheme";
import * as CONSTANT from "constants/text";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";

function MarketComingSoon() {
  return (
    <div className="header_main">
      <div
        className="page_main"
      >
        <div id="vertical_spotlight_details">
          <VerticalSpotlightDetails isSpotlightPage={false} />
        </div>
        <div className="page_details_main dummy-page d-block text-center" style={{flexGrow:1}}>
          <TextTheme
            message="Market Coming Soon"
            className="text_medium text_med_grey text_bold"
          />
        </div>
      </div>
    </div>
  );
}

export default MarketComingSoon;
